import InfoIcon from '@mui/icons-material/PermDeviceInformation';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  Divider,
  Grid, Paper
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import PageBanner from 'src/components/PageBanner';
import { AsyncState } from 'src/models';

const StyledPaper = styled(Paper)({
  flexGrow: 1,
  borderRadius: 0,
  padding: '1.3rem',
});


export const NavigationButtons: React.FC<{
  status: AsyncState,
  isLastForm: boolean,
  isAuthenticated: boolean | null,
  onPrevious: () => void;
  onNext: () => void
  onSave: () => void
}> = ({
  onPrevious, onNext, onSave, status, isLastForm, isAuthenticated
}) => (
    <>
      <Divider />
      <Box display="flex" component={Paper} borderRadius={0} padding={'10px 1.5rem'} justifyContent="space-between">
      <Button onClick={onPrevious} disabled={isAuthenticated === null || status === 'pending'} variant='contained' color='primary'>Previous</Button>
        <Box display={'flex'} alignItems={'center'}>
          <LoadingButton
            loading={isAuthenticated === null || status === 'pending'}
            style={{ marginRight: '20px' }}
            onClick={onSave}
            disabled={isAuthenticated === null || status === 'pending'}
            variant="contained">Save as draft
          </LoadingButton>
          <LoadingButton
            disabled={isAuthenticated === null || status === 'pending'}
            loading={isAuthenticated === null || status === 'pending'}
            onClick={onNext}
            variant="contained">{isLastForm ? 'Submit' : 'Next'}
          </LoadingButton>
        </Box>
      </Box>
    </>
  );

interface TabPanelProps {
  children?: React.ReactNode;
  pageTitle: string;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({
  children, value, index, pageTitle, ...other
}) => {
  const isActive = value === index;

  if (!isActive) return null;

  return (
    <Grid
      item
      xs={12}
      role="tabpanel"
      id={`vertical-tabpanel-${index}`}
      // border="1px solid black"
      // marginBottom={'12px'}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      <Grid item xs={12} height="100%" display="flex" flexDirection="column">
        <PageBanner
          title={pageTitle}
          subTitle={`Answer all questions on ${pageTitle.toLowerCase()}`}
          icon={<InfoIcon />}
        />
        <StyledPaper>{children}</StyledPaper>
      </Grid>
    </Grid>
  );
};

export default TabPanel
